<template>
  <div class='setWare'>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="checkWareList" class="demo-form-inline">
        <el-form-item label="仓房名称">
          <el-input v-model="checkWareList.wareName" placeholder="输入仓房名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getsetWareList(true)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        <el-button 
          type="primary" 
          class='commonBtn addNewWare' 
          icon='el-icon-circle-plus-outline' 
          @click="addNewWare('wareInfo')">添加仓房</el-button>
        <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class='delmarg'>
            <el-tab-pane label="平房仓" name="first" class='tab1' lazy>
              <div class='commonWareList' :style="`height:${height-192}px`">
                <div class='commonItem wareHouseItem' v-for='item in wareListInfo' :key='item.wareId'>
                  <div class='wareItemHead'>编号：{{item.warnNo}}</div>
                  <div class='wareHouseImg'></div>
                  <div class='setWareName'>{{item.wareName}}</div>
                  <div class='wareUpdate' v-if='item.updateTime'>更新时间：{{item.updateTime}}</div>
                  <div class='wareUpdate' v-else>创建时间：{{item.createTime}}</div>
                  <div class='setWareBtnList'>
                    <el-row>
                      <el-button type="primary" icon="el-icon-edit" circle class='setWareBtn' @click='getsetWareInfo(item.wareId)'></el-button>
                      <el-button type="danger" icon="el-icon-delete" circle class='setWareBtn' @click='deleteWare(item.wareId)'></el-button>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="浅圆仓" name="second" lazy>
              <div class='commonWareList' :style="`height:${height-192}px`">
                <div class='commonItem wareHouseItem' v-for='item in wareListInfo' :key='item.wareId'>
                  <div class='wareItemHead'>编号：{{item.warnNo}}</div>
                  <div class='squatSiloImg'></div>
                  <div class='setWareName'>{{item.wareName}}</div>
                  <div class='wareUpdate' v-if='item.updateTime'>更新时间：{{item.updateTime}}</div>
                  <div class='wareUpdate' v-else>创建时间：{{item.createTime}}</div>
                  <div class='setWareBtnList'>
                    <el-row>
                      <el-button type="primary" icon="el-icon-edit" circle class='setWareBtn' @click='getsetWareInfo(item.wareId)'></el-button>
                      <el-button type="danger" icon="el-icon-delete" circle class='setWareBtn' @click='deleteWare(item.wareId)'></el-button>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="油罐仓" name="three" lazy>
              <div class='commonWareList' :style="`height:${height-192}px`">
                <div class='commonItem wareHouseItem' v-for='item in wareListInfo' :key='item.wareId'>
                  <div class='wareItemHead'>编号：{{item.warnNo}}</div>
                  <div class='squatSiloImg'></div>
                  <div class='setWareName'>{{item.wareName}}</div>
                  <div class='wareUpdate' v-if='item.updateTime'>更新时间：{{item.updateTime}}</div>
                  <div class='wareUpdate' v-else>创建时间：{{item.createTime}}</div>
                  <div class='setWareBtnList'>
                    <el-row>
                      <el-button type="primary" icon="el-icon-edit" circle class='setWareBtn' @click='getsetWareInfo(item.wareId)'></el-button>
                      <el-button type="danger" icon="el-icon-delete" circle class='setWareBtn' @click='deleteWare(item.wareId)'></el-button>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :hide-on-single-page='true'
            :pageSize='checkWareList.pageSize' 
            :current-page='checkWareList.pageNum'
            @current-change='setWareChange'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
     <el-dialog 
      title="仓房信息" 
      :visible.sync="wareInfoShow" 
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-setWare-bg"'>
      <div class='formWrap'>
        <el-form ref="wareInfo" :model="wareInfo" label-width="100px" class='wareInfoForm' :rules='saveWareRules'>
          <div class='dialog-setWare-wrap'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>仓房基本信息</div>
            <div class='dialog-setWrap wareBaseInfo'>
              <el-form-item label="仓房名称" prop='wareName'>
                <el-input v-model="wareInfo.wareName" placeholder="请输入名称" @input='$forceUpdate()'></el-input>
              </el-form-item>
              <el-form-item label="仓房编号" prop='warnNo'>
                <el-input v-model.number="wareInfo.warnNo" placeholder="请输入数字" @input='$forceUpdate()'></el-input>
              </el-form-item>
              
              <el-form-item label="设计储量" prop='storageMax'>
                <el-input v-model.number="wareInfo.storageMax" placeholder="请输入数字" @input='$forceUpdate()'></el-input>
              </el-form-item>
              <el-form-item label="实际储量" prop='storageReal'>
                <el-input v-model.number="wareInfo.storageReal" placeholder="请输入数字" @input='$forceUpdate()'></el-input>
              </el-form-item>
              <el-form-item label="仓房高度" prop='height'>
                <el-input v-model="wareInfo.height" @input='$forceUpdate()' placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">m</i></el-input>
              </el-form-item>
              <el-form-item label="保管员" prop='custodian'>
                <el-input v-model.number="wareInfo.custodian" @input='$forceUpdate()' placeholder="请输入保管员"></el-input>
              </el-form-item>
              <el-form-item label="货位代码" prop='locatorCode'>
                <el-input v-model="wareInfo.locatorCode" placeholder="请输入货位代码" @input='$forceUpdate()' type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="仓房类型" class='wareTypeList' prop='wareType'>
                <el-radio-group v-model="wareInfo.wareType">
                  <el-radio 
                    :label="item.value" 
                    v-for='(item,index) in dict.type.ware_type' 
                    :key='index'>{{item.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if='wareInfo.wareType!=3'>
              <div class='baseInfoTitle'><span></span>存储粮食信息</div>
              <div class='dialog-setWrap foodBaseInfo'>
                <el-form-item label="粮食性质">
                  <el-select v-model="wareInfo.foodType" placeholder="请选择粮食性质">
                    <el-option 
                      :label="item.label" 
                      :value="item.value" 
                      v-for='item in dict.type.food_type' 
                      :key='item.dictCode'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="粮食品种">
                  <el-select v-model="wareInfo.foodFariety" placeholder="请选择粮食品种">
                    <el-option 
                      :label="item.label" 
                      :value="item.value" 
                      v-for='item in foodFariety' 
                      :key='item.dictCode'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="粮食等级">
                  <el-select v-model="wareInfo.foodLevel" placeholder="请选择粮食等级">
                    <el-option 
                      :label="item.label" 
                      :value="item.value" 
                      v-for='item in dict.type.food_level' 
                      :key='item.dictCode'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="粮食产地" prop='origin'>
                  <el-input v-model="wareInfo.origin" placeholder="请输入产地信息"></el-input>
                </el-form-item>
              </div>
            </div>
            <div v-if='wareInfo.wareType==3'>
              <div class='baseInfoTitle'><span></span>存储油脂信息</div>
              <div class='dialog-setWrap foodBaseInfo'>
                <el-form-item label="油脂性质" prop='foodType'>
                  <el-input v-model="wareInfo.foodType" placeholder="请输入油脂性质"></el-input>
                </el-form-item>
                <el-form-item label="油脂品种">
                  <el-select v-model="wareInfo.foodFariety" placeholder="请选择油脂品种">
                    <el-option 
                      :label="item.label" 
                      :value="item.value" 
                      v-for='item in oilFariety' 
                      :key='item.dictCode'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="油脂等级">
                  <el-select v-model="wareInfo.foodLevel" placeholder="请选择油脂等级">
                    <el-option 
                      :label="item.label" 
                      :value="item.value" 
                      v-for='item in dict.type.food_level' 
                      :key='item.dictCode'>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="油脂产地" prop='origin'>
                  <el-input v-model="wareInfo.origin" placeholder="请输入产地信息"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveWareInfo('wareInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  dicts:['ware_type','food_level','food_type'],
  data(){
    return{
      checkWareList:{
        pageNum:1,
        pageSize:15,
        isAsc:'desc',
        wareName:null,
        wareType:'0',
        orderByColumn:'wareId'
      },
      wareListInfo:[],
      total:0,
      activeName: 'first',
      wareInfo:{
        wareType:"0",
        imageList:[]
      },
      foodFariety:[],
      oilFariety:[],
      wareInfoShow:false,
      isAdd:false,
      loading:false,
      loading2:false,
      saveWareRules:{
        wareName:[
          {trigger:'blur',message:'仓房名称不能为空',required:true}
        ],
        warnNo:[
          {trigger:'blur',message:'仓房编码不能为空',required:true}
        ],
      }
    }
  },
  created(){
    this.isWareType();
    axios.get('/system/foodoiltype/getFoodOilTypeSelect').then(res=>{
      if(res){
        let data=res.data;
        this.foodFariety=data.foodTypeList.map(item=>{
          return{
            label:item.foodName,
            value:item.dataId.toString()
          }
        });
        this.oilFariety=data.oilTypeList.map(item=>{
          return{
            label:item.foodName,
            value:item.dataId.toString()
          }
        })
      }
    })
  },
  methods:{
    handleClick(tab){
      if(tab.index==2){
        this.checkWareList.wareType=3;
        this.wareInfo.wareType='3';
        this.wareListInfo=[]
      }else{
        this.checkWareList.wareType=tab.index;
        this.wareInfo.wareType=tab.index;
        this.wareListInfo=[]
      }
      this.setWareLoading2()
      this.getsetWareList()
    },
    isWareType(){
      axios.get('/system/house/getHouseType').then(res=>{
        if(res){
          if(res.data.pExist){
            this.activeName='first';
            this.checkWareList.wareType='0'
            this.wareInfo.wareType='0';
          }else if(res.data.qExist){
            this.activeName='second';
            this.checkWareList.wareType='1'
            this.wareInfo.wareType='1';
          }else if(res.data.yExist){
            this.activeName='three';
            this.checkWareList.wareType='3'
            this.wareInfo.wareType='3';
          }else{
            this.$message({
              type: 'warning',
              message: '暂无仓房，请添加仓房!',
              duration:2000
            });
          }
          this.getsetWareList();
        }
      })
    },
    getsetWareList(){
      axios.get('/system/house/list',{params:this.checkWareList}).then(res=>{
        if(this.loading2){
          this.loading2.close()
        }
        if(res){
          this.total=res.total;
          this.wareListInfo=res.rows;
        }
      })
    },
    addNewWare(){
      this.wareInfoShow=true;
      this.isAdd=true;
    },
    // 设置加载动画
    setWareLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setWare-bg')
      })
    },
    setWareLoading2(){
      this.loading2=this.$loading({
        text:'请稍等',
        target:document.querySelector('.setMacView')
      })
    },
    getsetWareInfo(wareId){
      axios.get(`/system/house/${wareId}`).then(res=>{
        if(res){
          this.wareInfoShow=true;
          this.wareInfo=res.data;
          this.isAdd=false;
        }
      })
    },
    saveWareInfo(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          this.setWareLoading();
          if(this.isAdd){
            axios.post('/system/house',this.wareInfo).then(data=>{
              this.loading.close()
              if(data){
                this.checkWareList.wareType=this.wareInfo.wareType
                if(this.wareInfo.wareType==0){
                  this.activeName='first'
                }else if(this.wareInfo.wareType==1){
                  this.activeName='second'
                }else{
                  this.activeName='three'
                }
                this.getsetWareList();
                this.$message({
                  type: 'success',
                  message: '添加成功!',
                  duration:1000
                });
                this.wareInfoShow=false;
                this.isAdd=false
              }
            })
          }else{
            axios.put('/system/house',this.wareInfo).then(data=>{
              this.loading.close()
              if(data){
                this.checkWareList.wareType=this.wareInfo.wareType
                if(this.wareInfo.wareType==0){
                  this.activeName='first'
                }else if(this.wareInfo.wareType==1){
                  this.activeName='second'
                }else{
                  this.activeName='three'
                }
                this.getsetWareList();
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                  duration:1000
                });
                this.wareInfoShow=false;
              }
            })
          }
        }else{
          return false
        }
      })
    },
    deleteWare(wareId){
      this.$confirm('此操作将永久删除该仓房, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/house/delete/${wareId}`).then(data=>{
          if(data){
            this.getsetWareList()
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });   
      })
    },
    setWareChange(val){
      this.checkWareList.pageNum=val;
      this.getsetWareList()
    }
  }
}
</script>

<style>
  .setWare{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .addNewWare{
    left:15px
  }
  .wareHouseItem{
    margin:10px 10px 8px 8px;
    width: 300px;
    height: 207px;
  }
  .wareItemHead{
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: rgba(53,98,255,0.12);
    color: #3562FF;
    font-weight: 600;
    font-size: 14px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 4px;
  }
  .wareHouseImg{
    width: 146px;
    height: 101px;
    background-image: url('../../assets/ware/wareHouse.png');
    background-size: cover
  }
  .squatSiloImg{
    height: 101px;
    width:81px;
    background-image: url("../../assets/ware/squatSilo.png");
    background-size: cover
  }
  .setWareName{
    font-size: 16px;
    font-weight: 600;
    margin-top: 5px
  }
  .wareUpdate{
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,0.35);
    position: absolute;
    left: 10px;
    bottom: 10px;
    height: 24px;
    line-height: 24px;
  }
  .setWareBtnList{
    position: absolute;
    bottom: 10px;
    right:10px;
  }
  .setWareBtn{
    margin: 2px !important;
    padding: 5px !important
  }
  .dialog-setWare-bg{
    width: 740px !important;
  }
  .wareBaseInfo,.foodBaseInfo,.cableBaseInfo{
    width:700px;
    flex-wrap: wrap
  }
  .foodBaseInfo{
    height: 120px;
  }
  .wareBaseInfo .el-form-item,.foodBaseInfo .el-form-item,.cableBaseInfo .el-form-item{
    width: 50%
  }
  .wareBaseInfo .wareTypeList{
    width: 100%;
    margin-bottom: 10px
  }
</style>